import React, { useState, useEffect } from "react";
import { Button, Segment, Header, Icon, Label, Popup, Grid } from "semantic-ui-react";
import { DragDropTableRow } from "./DragDropTableRow";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import { uniq } from "lodash";
import { DragDropTableStyles as st } from "./styles";

const SortableItem = sortableElement(
	({ analysis, index, analysesFactory, removeAnalysisFromSet, addAnalysisToSet, isSecretary, isMobile, saveMotivation, checkAnalysis }) => (
		<DragDropTableRow
			analysesFactory={analysesFactory}
			analyse={analysis}
			index={index}
			removeAnalysisFromSet={removeAnalysisFromSet}
			addAnalysisToSet={addAnalysisToSet}
			isSecretary={isSecretary}
			isMobile={isMobile}
			saveMotivation={saveMotivation}
			checkAnalysis={checkAnalysis}
		/>
	)
);

const SortableContainer = sortableContainer(({ children }) => {
	return <div>{children}</div>;
});

export const DragDropTable = ({
	analyses,
	analysesFactory,
	removeAnalysisFromSet,
	addAnalysisToSet,
	removeAllAnalyses,
	isSecretary,
	lang,
	isMobile,
	saveMotivation,
	hasTvSecComments,
	checkAnalysis,
}) => {
	const [items, setItems] = useState(analyses.sort((a, b) => (a.order < b.order ? -1 : a.order > b.order ? 1 : 0)));
	useEffect(() => {
		setItems((i) =>
			items
				.concat(analysesFactory?.add.filter((a) => !items.some((i) => i.code === a.code)))
				.filter((a) => analyses.concat(analysesFactory?.add).some((an) => an.code === a.code))
		);
	}, [analysesFactory]);

	const arrayMove = require("array-move");
	const onSortEnd = ({ oldIndex, newIndex }) => {
		let newArray = arrayMove(items, oldIndex, newIndex);
		setItems(newArray);
		analysesFactory.order = newArray.map((a) => a.properties?.code || a.code);
	};

	return (
		<Segment style={{ ...st.segmentContainer, height: hasTvSecComments ? "calc(100vh - 250px)" : "calc(100vh - 179px)" }}>
			<Label color="teal" style={st.ribbonHeader} ribbon>
				Analyses sélectionnées (
				{
					analyses
						.concat(uniq(analysesFactory.add))
						.filter((a) => !analysesFactory?.remove.some((an) => (an.properties?.code ?? a.code) === (a.properties?.code ?? a.code))).length
				}
				)
			</Label>

			{analyses.concat(analysesFactory.add).length === 0 && (
				<div style={st.noAnalysis}>
					<Header icon>
						<Icon name="search" />
						Aucune analyse sélectionnée
					</Header>
				</div>
			)}
			{analyses.concat(analysesFactory.add).length > 0 && (
				<Grid>
					<Grid.Row style={{ padding: "5px" }}>
						<Grid.Column>
							<div style={{ display: "flex", justifyContent: "end" }}>
								<Button
									onClick={() => removeAllAnalyses()}
									size="mini"
									style={isMobile ? st.header.removeAllButtonMobile : st.header.removeAllButton}
								>
									<Icon name="close" />
									Supprimer toutes les analyses
								</Button>
							</div>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row style={{ padding: "5px" }}>
						<Grid.Column style={{ padding: "4px" }}>
							<div style={st.header.container}>
								<div style={st.header.content}>
									{!isSecretary && (
										<Popup
											content="La case à cocher à côté du code est utilisée pour vérifier la liste d'analyses par rapport à l'ordonance."
											trigger={<div style={st.header.popupCheckbox}>CODE</div>}
										/>
									)}
									{isSecretary && (
										<Popup
											content="La case à cocher à côté du code est utilisée par les secrétaires pour vérifier la liste d'analyses lors de l'encodage"
											trigger={<div style={st.header.popupCheckbox}>CODE</div>}
										/>
									)}
									<div style={st.header.space}></div>
									<div style={st.header.label}>LABEL</div>
								</div>
							</div>
							<div
								style={{
									...(isMobile ? st.itemsMobile.container : st.items.container),
									height: hasTvSecComments ? "calc(100vh - 345px)" : "calc(100vh - 280px)",
								}}
							>
								<SortableContainer onSortEnd={onSortEnd} axis="y" distance={1} lockAxis="y" lockToContainerEdges={true} lockOffset={["30%", "50%"]}>
									{items.map((a, index) => {
										if (lang === "en") {
											a.lab = a.label_en || a.label;
											a.descr = a.synonymous_en || a.description;
										}
										if (lang === "de") {
											a.lab = a.label_de || a.label;
											a.descr = a.synonymous_de || a.description;
										}
										if (lang === "fr") {
											a.lab = a.label;
											a.descr = a.description;
										}
										return (
											<SortableItem
												key={`ddt-${a.id}`}
												analysis={a}
												index={index}
												analysesFactory={analysesFactory}
												removeAnalysisFromSet={removeAnalysisFromSet}
												addAnalysisToSet={addAnalysisToSet}
												isSecretary={isSecretary}
												isMobile={isMobile}
												saveMotivation={saveMotivation}
												checkAnalysis={checkAnalysis}
											/>
										);
									})}
								</SortableContainer>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			)}
		</Segment>
	);
};
